import { Link, useLocation } from "@tanstack/react-router";

import { SideNav, type SideNavItem } from "@/components/ui/SideNav";

const NAV_ITEMS: SideNavItem[] = [
  { href: "/admin/design-system", label: "Overview", match: "exact" },
  { href: "/admin/design-system/explore", label: "Explore", match: "prefix" },
  { href: "/admin/design-system/fonts", label: "Fonts", match: "prefix" },
  { href: "/admin/design-system/colors", label: "Colors", match: "prefix" },
  { href: "/admin/design-system/components", label: "Components", match: "prefix" },
  { href: "/admin/design-system/sections", label: "Sections", match: "prefix" },
  { href: "/admin/design-system/casing", label: "Casing", match: "prefix" },
  { href: "/admin/design-system/saved", label: "Saved", match: "prefix" },
];

export function DesignSystemSidebar() {
  const { pathname } = useLocation();

  return (
    <aside
      className="flex min-h-0 w-full shrink-0 flex-col border-b-[3px] border-neutral-950 bg-[#fffaf1] px-5 py-8 shadow-[8px_8px_0_rgba(19,19,19,0.1)] lg:min-h-screen lg:w-56 lg:border-b-0 lg:border-r-[3px] lg:shadow-[6px_0_0_rgba(19,19,19,0.08)]"
      aria-label="Design system"
    >
      <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-neutral-600">Design system</p>
      <p className="mt-2 text-xs leading-relaxed text-neutral-700">
        UI tokens, primitives, and links to map asset tooling.
      </p>
      <SideNav
        items={NAV_ITEMS}
        pathname={pathname}
        label="Design system sections"
        className="mt-8"
      />
      <div className="mt-auto flex flex-col gap-3 pt-10">
        <Link
          to="/admin"
          className="text-sm font-medium underline decoration-2 underline-offset-4 hover:text-neutral-700"
        >
          Developer hub
        </Link>
        <Link
          to="/"
          className="text-sm font-medium underline decoration-2 underline-offset-4 hover:text-neutral-700"
        >
          Back to West Marches
        </Link>
      </div>
    </aside>
  );
}
